import {
  Button,
  IconValidationValid,
  Stack,
  Text,
} from '@adc/parallax-component-library';
import { Dialog } from '@tamagui/dialog';

import { useModal } from '~/features/modals/useModal';
import { buildTestId } from '~/utils/buildTestId';

import { ModalOverlay } from '../ModalOverlay';

type AdminUserAddedModalProps = {
  testID: string;
  id: number;
  name: string;
  onViewUserProfile: (userId: number) => Promise<void>;
};

export const AdminUserAddedModal = ({
  testID,
  id,
  name,
  onViewUserProfile,
}: AdminUserAddedModalProps) => {
  const { closeModal } = useModal();

  const onClose = () => {
    closeModal('AdminUserAdded');
  };

  const onOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open onOpenChange={onOpenChange} modal>
      <Dialog.Portal>
        <ModalOverlay />

        <Dialog.Content
          testID={testID}
          key="content"
          elevate
          animateOnly={['transform', 'opacity']}
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          enterStyle={{ x: 0, y: 20, opacity: 0 }}
          exitStyle={{ x: 0, y: 10, opacity: 0, scale: 0.95 }}
          padding="$6"
          paddingBottom="$12"
          borderWidth="$0"
          maxWidth={800}
          width="100%"
          minHeight={500}
          alignContent="center"
          justifyContent="space-between"
          borderRadius="$1.5"
          backgroundColor="$surface.background"
          alignItems="center"
        >
          <Stack alignItems="center">
            <IconValidationValid size="L" color="$support.positive.default" />
            <Text
              type="$h3.strong"
              testID={buildTestId({
                testID,
                suffix: 'title',
              })}
            >
              User Added
            </Text>

            <Text type="$bodySmall.default" color="$text.60" paddingTop="$3">
              {name} was added to the IDN.
            </Text>
          </Stack>
          <Stack>
            <Button
              variant="secondary"
              label="View User Profile"
              onPress={() => void onViewUserProfile(id)}
              marginTop="$6"
              // @ts-expect-error Parallax doesn't type this prop
              minWidth={256}
              testID={buildTestId({
                testID,
                suffix: ['button', 'user', 'profile'],
              })}
            />

            <Button
              variant="primary"
              label="Done"
              onPress={onClose}
              marginTop="$2"
              // @ts-expect-error Parallax doesn't type this prop
              minWidth={256}
              testID={buildTestId({
                testID,
                suffix: ['button', 'done'],
              })}
            />
          </Stack>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  );
};
